import { render, staticRenderFns } from "./FormularioCadastro.vue?vue&type=template&id=f5c5b3b4&scoped=true&"
import script from "./FormularioCadastro.vue?vue&type=script&lang=js&"
export * from "./FormularioCadastro.vue?vue&type=script&lang=js&"
import style0 from "./FormularioCadastro.vue?vue&type=style&index=0&id=f5c5b3b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c5b3b4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VForm,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5c5b3b4')) {
      api.createRecord('f5c5b3b4', component.options)
    } else {
      api.reload('f5c5b3b4', component.options)
    }
    module.hot.accept("./FormularioCadastro.vue?vue&type=template&id=f5c5b3b4&scoped=true&", function () {
      api.rerender('f5c5b3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Perfil/components/FormularioCadastro.vue"
export default component.exports